let accessToken = null;
const listeners = new Set();

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(token) {
  accessToken = token || null;
  listeners.forEach((listener) => listener(accessToken));
}

export function clearAccessToken() {
  setAccessToken(null);
}

export function subscribeAccessToken(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
